import { Component, OnInit } from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { moveItemInArray, CdkDragDrop } from '@angular/cdk/drag-drop';
import { ConfigurationGroupModel } from 'src/app/components/configuration/models/configurationGroupModel';
import { ManageConfigurationModel } from 'src/app/components/configuration/models/manageConfigurationModel';
import { environment } from 'src/environments/environment';
import { RestAPIService } from 'src/app/services/restapi.service';

@Component({
    selector: 'app-manage-configuration',
    templateUrl: './configuration.manage.component.html',
})
export class ManageConfigurationComponent implements OnInit {
    submitted: boolean = false;
    manageConfigurationModel: ManageConfigurationModel= new ManageConfigurationModel();
    configurationGroupList: ConfigurationGroupModel[] = [];
    productCode: string | undefined;
    configurationId: string | undefined;
    singleConfigurationTypeCode = "S";
    matrixConfigurationTypeCode = "M";
    listConfigurationTypeCode = "L";
    rangeConfigurationTypeCode = "R";

    name = new FormControl('', [Validators.required]);
    description = new FormControl('', [Validators.required]);
    
    constructor(public _restAPI: RestAPIService,
        private route: ActivatedRoute, 
        private router: Router) {
            this._restAPI.loading  = false;
            localStorage.setItem('reloadConfigurationSearchModel', 'true');
        }

    //#region Get query params
    getQueryParams(): void {
        this.route
            .queryParams
            .subscribe(params => {
                // Defaults to 0 if no query param provided.
                let productCode = params['productCode'] as string;
                this.productCode = productCode || '';
                if (this.productCode === null || this.productCode.length <= 0) {
                    this.router.navigateByUrl('/configuration');
                }

                let configurationId = params['configurationId'] as string;
                this.configurationId = configurationId || '';
                if (this.configurationId === null || this.configurationId.length <= 0) {
                    this.router.navigateByUrl('/configurationdetails?productCode=' + this.productCode);
                }
            });
    }
    //#endregion

    async ngOnInit() {
        this.getQueryParams();
        await this.getConfigurationGroupList();
        await this.getConfigurationById();
        this.reOrderIndexPositions();
    }

    //#region dropped event
    dropped(event: CdkDragDrop<any[]>) {
        moveItemInArray(
            this.manageConfigurationModel.configurationChildList,
            event.previousIndex,
            event.currentIndex
        );
        this.reOrderIndexPositions();
    }
    //#endregion

    //#region Re order index positions

    reOrderIndexPositions(): void {        
        if (this.manageConfigurationModel?.configurationChildList?.length > 0) {
            for(let i = 0; i < this.manageConfigurationModel.configurationChildList.length; i++) {
                this.manageConfigurationModel.configurationChildList[i].indexPosition = i;
            }
        }
    }

    //#endregion

    async getConfigurationGroupList() {
        this._restAPI.loading  = true;
        this._restAPI.get<ConfigurationGroupModel[]>(environment.apiURL + 'api/configuration/' + this.productCode + '/group').subscribe({
            next: (data) => {
                this._restAPI.loading  = false;
                this.configurationGroupList = data;
            },
            error: (error) => {this._restAPI.loading  = false; console.error(error);}
        });
    }
    
    async getConfigurationById() {
        this._restAPI.loading  = true;
        this._restAPI.get<ManageConfigurationModel>(environment.apiURL + 'api/configuration/' + this.productCode + '/' + this.configurationId).subscribe({
            next: (data) => {
                this._restAPI.loading  = false;
                this.manageConfigurationModel = data;            
            if (this.manageConfigurationModel != null) {
                let group = this.configurationGroupList.find(x => x.groupId === this.manageConfigurationModel.groupId);
                if (group != null) {
                    this.manageConfigurationModel.groupName = group.groupName;
                }
            }
            },
            error: (error) => {this._restAPI.loading  = false; console.error(error)}
        });
    }

    addListRow() {
        let indexPosition = 0;
        if (this.manageConfigurationModel != null && (this.manageConfigurationModel.configurationChildList === null || this.manageConfigurationModel.configurationChildList.length <= 0)) {
            this.manageConfigurationModel.configurationChildList = [];
        }
        else {
            indexPosition = this.manageConfigurationModel.configurationChildList.length;
        }

        this.manageConfigurationModel.configurationChildList.push({
            listId: '00000000-0000-0000-0000-000000000000',
            code: '',
            description: '',
            isActive: true,
            indexPosition: indexPosition,
            createdBy: '',
            createdDate: null,
            updatedBy: '',
            updatedDate: null
        });
    }

    addRangeRow() {
        let indexPosition = 0;
        if (this.manageConfigurationModel != null && (this.manageConfigurationModel.configurationChildList === null || this.manageConfigurationModel.configurationChildList.length <= 0)) {
            this.manageConfigurationModel.configurationChildList = [];
        }
        else {
            indexPosition = this.manageConfigurationModel.configurationChildList.length;
        }

        this.manageConfigurationModel.configurationChildList.push({
            rangeId: '00000000-0000-0000-0000-000000000000',
            minValue: '',
            maxValue: '',
            isActive: true,
            indexPosition: indexPosition,
            createdBy: '',
            createdDate: null,
            updatedBy: '',
            updatedDate: null
        });
    }

    addMatrixRow() {
        let indexPosition = 0;
        if (this.manageConfigurationModel != null && (this.manageConfigurationModel.configurationChildList === null || this.manageConfigurationModel.configurationChildList.length <= 0)) {
            this.manageConfigurationModel.configurationChildList = [];
        }
        else {
            indexPosition = this.manageConfigurationModel.configurationChildList.length;
        }

        this.manageConfigurationModel.configurationChildList.push({
            matrixValueId: '00000000-0000-0000-0000-000000000000',
            matrixId:this.manageConfigurationModel.configurationMatrix.matrixId,
            conditionData1: '',
            conditionData2: '',
            conditionData3: '',
            conditionData4: '',
            conditionData5: '',
            value: '',
            isActive: true,
            indexPosition: indexPosition,
            createdBy: '',
            createdDate: null,
            updatedBy: '',
            updatedDate: null
        });
    }

    async saveConfiguration() {
        this.submitted = true;
        if(this.validateList() && !this.name.invalid && !this.description.invalid){
            let postData = {};
            let key = "/L/";
            if (this.manageConfigurationModel.configurationTypeCode == this.listConfigurationTypeCode)  {
                postData = this.manageConfigurationModel;
            }
            else if (this.manageConfigurationModel.configurationTypeCode == this.rangeConfigurationTypeCode)  {
                key = "/R/";
                postData = this.manageConfigurationModel;
            }
            else if (this.manageConfigurationModel.configurationTypeCode == this.matrixConfigurationTypeCode)  {
                key = "/M/";
                postData = {
                    name: this.manageConfigurationModel.name,
                    description: this.manageConfigurationModel.description,
                    configurationChildList: this.manageConfigurationModel.configurationChildList
                }
            }
            else if (this.manageConfigurationModel.configurationTypeCode == this.singleConfigurationTypeCode)  {
                key = "/";
                postData = this.manageConfigurationModel;
            }
            this._restAPI.loading  = true;
            this._restAPI.put<string>(environment.apiURL + 'api/configuration/' + this.productCode + key + this.configurationId, postData).subscribe({
                next: (data) => {
                    this._restAPI.loading  = false;
                    this.submitted = false;
                this.router.navigate(['/configurationdetails'], { queryParams: { productCode: this.productCode} });
                },
                error: (error) => {this._restAPI.loading  = false;console.error(error)}
            });
        }
    }

    validateList(): boolean {
        const model = this.manageConfigurationModel;
        const children = model?.configurationChildList ?? [];
    
        if (children.length === 0) {
            return true;
        }
    
        for (const item of children) {
            switch (model.configurationTypeCode) {
                case this.listConfigurationTypeCode:
                    if (!this.hasValue(item.code) || !this.hasValue(item.description)) {
                        return false;
                    }
                    break;
    
                case this.rangeConfigurationTypeCode:
                    if (!this.hasValue(item.minValue) || !this.hasValue(item.maxValue)) {
                        return false;
                    }
                    break;
    
                case this.matrixConfigurationTypeCode:
                {
                    const matrix = model.configurationMatrix;
    
                    if (this.hasCondition(matrix.condition1) && !this.isValidGuid(item.conditionData1)) return false;
                    if (this.hasCondition(matrix.condition2) && !this.isValidGuid(item.conditionData2)) return false;
                    if (this.hasCondition(matrix.condition3) && !this.isValidGuid(item.conditionData3)) return false;
                    if (this.hasCondition(matrix.condition4) && !this.isValidGuid(item.conditionData4)) return false;
                    if (this.hasCondition(matrix.condition5) && !this.isValidGuid(item.conditionData5)) return false;
    
                    if (matrix.hasValue && !this.hasValue(item.value)) {
                        return false;
                    }
                    break;
                }
            }
        }
    
        return true;
    }

    private hasValue(value: string | null | undefined): boolean {
        return value != null && value.trim().length > 0;
    }
    
    private hasCondition(condition: any): boolean {
        return condition != null;
    }
    
    private isValidGuid(value: string | null | undefined): boolean {
        const emptyGuid = '00000000-0000-0000-0000-000000000000';
        return this.hasValue(value) && value !== emptyGuid;
    }
}
